module.exports = __webpack_public_path__ + "img/public/AdminIcons/dlt.png?bd8e4b34";